<template>
  <div>
    {{ time }}
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    start: {
      type: String,
      default: null
    }
  }
})
export default class Timer extends Vue {
  data () {
    return {
      intervalTime: 1000,
      interval: null,
      time: null
    }
  }

  mounted () {
    this.initialize()
  }

  toHHMMSS (time) {
    const date = new Date(time)

    let hours = Math.floor(time/1000/60/60)
    hours = hours < 10 ? `0${hours}` : hours
    const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
    const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()

    return `${hours}:${minutes}:${seconds}`
  }
  
  initialize () {
    const start = this.start ? new Date(this.start) : new Date()

    this.interval = setInterval(() => {
      const currentTime = new Date().getTime()
      const callTime = currentTime - start

      this.time = this.toHHMMSS(callTime)
    }, this.intervalTime)
  }
}
</script>